module.exports = __webpack_public_path__ + "static/img/script-task.82657b4f.svg";